<script setup>
import { computed } from 'vue'
import { CRITERIA } from '../lib/criteria.js'
import { money, num, pct } from '../lib/format.js'

const props = defineProps({ totals: { type: Object, required: true } })

const kpis = computed(() => {
  const t = props.totals
  return [
    { label: 'Leads no gestionados', value: num(t.unmanaged), hint: `${num(t.unmanagedContacts)} contactos unicos`, tone: 'critico' },
    { label: '% del total activo', value: pct(t.rate), hint: `sobre ${num(t.openOpportunities)} opps abiertas + ${num(t.contacts)} contactos` },
    { label: 'Valor en riesgo', value: money(t.valueAtRisk), hint: 'suma del valor de las oportunidades detectadas' },
    { label: 'Antiguedad media', value: `${t.avgDaysStuck} d`, hint: 'dias promedio sin avanzar de etapa' },
    { label: 'Criticos', value: num(t.bySeverity.critico), hint: `${num(t.bySeverity.alto)} altos · ${num(t.bySeverity.medio)} medios`, tone: 'critico' },
  ]
})

const motivos = computed(() =>
  Object.values(CRITERIA)
    .map((c) => ({ ...c, count: props.totals.byReason[c.id] || 0 }))
    .filter((c) => c.count > 0)
    .sort((a, b) => b.count - a.count),
)

const maxMotivo = computed(() => Math.max(1, ...motivos.value.map((m) => m.count)))
</script>

<template>
  <div class="kpis">
    <div v-for="k in kpis" :key="k.label" class="card kpi">
      <h3>{{ k.label }}</h3>
      <strong :class="k.tone">{{ k.value }}</strong>
      <span class="muted">{{ k.hint }}</span>
    </div>
  </div>

  <div v-if="motivos.length" class="card motivos">
    <h3>Reparto por motivo <span class="muted">(un lead puede acumular varios)</span></h3>
    <div v-for="m in motivos" :key="m.id" class="motivo" :title="m.help">
      <span class="nombre">{{ m.label }}</span>
      <span class="barra"><i :style="{ width: (m.count / maxMotivo * 100) + '%', background: m.color }" /></span>
      <span class="mono valor">{{ num(m.count) }}</span>
    </div>
  </div>
</template>

<style scoped>
.kpis { display: grid; grid-template-columns: repeat(auto-fit, minmax(190px, 1fr)); gap: 12px; margin-bottom: 12px; }
.kpi { padding: 14px 16px; display: grid; gap: 4px; }
.kpi strong { font-size: 26px; letter-spacing: -.02em; line-height: 1.15; }
.kpi strong.critico { color: var(--critico); }
.kpi span { font-size: 12px; }
.motivos { padding: 14px 16px; margin-bottom: 16px; display: grid; gap: 8px; }
.motivo { display: grid; grid-template-columns: minmax(150px, 220px) 1fr 56px; gap: 12px; align-items: center; font-size: 13px; }
.barra { height: 8px; background: var(--surface-2); border-radius: 999px; overflow: hidden; }
.barra i { display: block; height: 100%; border-radius: 999px; }
.valor { text-align: right; font-weight: 600; }
@media (max-width: 640px) { .motivo { grid-template-columns: 1fr 44px; } .barra { grid-column: 1 / -1; } }
</style>
